import { render, staticRenderFns } from "./BrandResultView.vue?vue&type=template&id=9435f68e&"
import script from "./BrandResultView.vue?vue&type=script&lang=js&"
export * from "./BrandResultView.vue?vue&type=script&lang=js&"
import style0 from "./BrandResultView.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports